module.exports = __webpack_public_path__ + "img/Mb_Lobby_Video.c6becd8b.jpg";